import { AnalyticsService } from 'src/app/services/analytics.service';
import { Router, NavigationExtras } from '@angular/router';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import {firstBy} from 'thenby';
import { CustomDialogService } from 'src/app/shared/custom-dialog.service';
import { AppConstant } from 'src/app/utilities/app.constants';

@Component({
  selector: 'app-crew-ratings-list-view',
  templateUrl: './crew-ratings-list-view.component.html',
  styleUrls: ['./crew-ratings-list-view.component.scss']
})
export class CrewRatingsListViewComponent implements OnInit, OnChanges {

  @Input() crewId: string;

  @Input() crewRatings = [];

  page = 0;
  pageSize = 25;
  collectionSize = 0;

  constructor(
    private router: Router,
    private readonly analyticsService: AnalyticsService,
    private customDialogService: CustomDialogService
    ) { }

  ngOnInit() {
  }

  async ngOnChanges() {
    this.crewRatings = await this.crewRatings.map(rating => {
      rating.createdAt = rating.createdAt.substr(0, 10);
      return rating;
    });
    this.crewRatings.sort(firstBy('createdAt').thenBy('finalRating', -1));
    this.collectionSize = this.crewRatings.length;
  }

  openSafetyRatingFeedback(safetyRating: any) {
    console.log('safetyRating ',safetyRating);
    let navigationExtras: NavigationExtras = {
      queryParams: {
          "Id": safetyRating._id,
          "rank": safetyRating.rank
      }
  }; 
    this.router.navigate([`analytics/safety-rating-feedback/${safetyRating._id}`],navigationExtras);
  }

  ratingScale() {
    this.customDialogService.showRatingScaleDialogue(AppConstant.Rating_Scale,'ratingScale');
  }
}
